import { createReducer, on } from '@ngrx/store';

import * as actions from '@shared/base-search-bar/store/actions/search-bar.actions';
import {
  AutoCompleteDestination, LocationTypeIcon, LocationTypePriority
} from '@shared/base-search-bar/entities/autocomplete-destionation';

export const initialState: AutoCompleteDestination = {
  hotels: [],
  locations: []
};

export const autocompleteDestinationPlacesReducer = createReducer(
  initialState,
  on(actions.searchDestinationPlacesSuccessAction, (state, { response }) => {
    return mapDestinationPlacesAutocomplete(response);
  }),
  on(
    actions.resetAutocomplete,
    actions.selectHotelDestinationPlaceAction,
    () => initialState
  ),
);

function mapDestinationPlacesAutocomplete(response: AutoCompleteDestination): AutoCompleteDestination {
  const formatList = {
    hotels: response.hotels.filter(hotel => !!hotel?.hotel_name && !!hotel?.address && !!hotel?.Id),
    locations: response.locations
      .filter(location => !!location?.Name && !!location?.NameFull && !!location?.Id)
      .map(location => {
        return {
          ...location,
          TypeIcon: LocationTypeIcon[location.Type] || LocationTypeIcon.Default,
          TypePriority: LocationTypePriority[location.Type] || LocationTypePriority.Default
        };
      })
      .sort((a, b) => a.TypePriority - b.TypePriority)
  };
  return formatList;
}
